import React from 'react';

import { fieldRegistry } from './fields/fieldRegistry';
import type { FieldConfig } from '@/types/forms';

type FormFieldRendererProps = {
  field: FieldConfig;
  control: any;
  errors: any;
};

export function FormFieldRenderer({
  field,
  control,
  errors,
}: FormFieldRendererProps) {
  const error = errors[field.name]?.message as string | undefined;
  const colSpanClass =
    field.colSpan === 2 || field.fullWidth ? 'md:col-span-2' : '';

  const sharedProps = {
    name: field.name as any,
    label: field.label,
    required: field.required,
    control,
    error,
    colSpan: field.colSpan,
  };

  const render = fieldRegistry[field.type];
  const node = render ? render(sharedProps, field) : null;

  return (
    <>
      {field.dividerBefore && <hr className="border-gray-200 md:col-span-2" />}
      <div className={colSpanClass}>{node}</div>
    </>
  );
}
